import { useApi } from 'services';

export const useGetPolicies = () => useApi(`/endorsements`, 'GET', {}, {});

export const useGetPoliciesExport = () => useApi(`/report/endorsements/xlsx`, 'GET', {}, {});

export const usePolicyPackListDirectors = (idOperation) => useApi(`/quote/policy/director-approval/list-directors/${idOperation}`, 'GET', {}, {}, true);

export const usePolicyPackSendDirector = () => useApi(`/quote/policy/send-director`, 'POST', {}, {}, true);